import React from "react";

export default function IconReports() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6.12575V12.2336M9 8.41618V12.2336M6 10.7066V12.2336M4.5 15.2875H13.5C14.3284 15.2875 15 14.6038 15 13.7605V4.59879C15 3.75548 14.3284 3.07184 13.5 3.07184H4.5C3.67157 3.07184 3 3.75548 3 4.59879V13.7605C3 14.6038 3.67157 15.2875 4.5 15.2875Z"
        stroke="#3F3F46"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
